/**
 * サービス用スクリプト。
 *
 * @format
 */
// スタイルシートの読み込み
// ここで読み込む事でSCSSがWebpack側でビルドされます。
import "../../css/build/main.scss";
// jQuery
// https://www.npmjs.com/package/jquery
// このスクリプト内では直接jQueryを利用していない為、
// import ではなく require でモジュールを読み込んでいます。
// import にすると未使用の参照がビルド時に削除されるので注意してください。
// import $ from "jquery";
require("jquery");
// // jquery.easing
// // https://www.npmjs.com/package/jquery.easing
// require("jquery.easing");
// Bootstrap5
// https://getbootstrap.jp/docs/5.0/getting-started/introduction/
// https://www.npmjs.com/package/bootstrap
import "bootstrap";
// // ページの一番上に戻るボタンの動作設定
// import "./app/pageTopBtn";
// // ページ内リンクの挙動修正
// import "./app/linkEvent";
/**
 * ウインドウのロードイベント。
 */
function windowLoaded() {
    // トグルボタン
    var toggleButtons = document.getElementsByClassName("js_toggleBtn");
    if (toggleButtons.length > 0) {
        var _loop_1 = function () {
            var toggleButton = toggleButtons[i];
            if (toggleButton instanceof HTMLElement) {
                var className_1 = toggleButton.dataset["toggle_class"];
                var targetSelector = toggleButton.dataset["toggle_selector"];
                var target_1 = null;
                if (targetSelector) {
                    target_1 = document.querySelector(targetSelector);
                }
                toggleButton.addEventListener("click", function () {
                    var hasFlag = toggleButton.classList.contains(className_1);
                    if (hasFlag) {
                        $("#headerMenus").slideUp();
                        toggleButton.classList.remove(className_1);
                        if (target_1) {
                            target_1.classList.remove(className_1);
                        }
                    }
                    else {
                        $("#headerMenus").slideDown();
                        toggleButton.classList.add(className_1);
                        if (target_1) {
                            target_1.classList.add(className_1);
                        }
                    }
                });
            }
        };
        for (var i = 0; i < toggleButtons.length; i++) {
            _loop_1();
        }
    }
    // Twitterの表示領域切り替え
    var $twitterSp = $("#js_twitterContainer_sp");
    var $twitterPc = $("#js_twitterContainer_pc");
    var $body = $(document.body);
    var isTopPage = $body.hasClass("page_index");
    if ($twitterPc.length == 1 && $twitterSp.length) {
        var pcBorder = 768;
        var isPc_1 = null;
        var $window_1 = $(window);
        var onResize = function () {
            var newValue = $window_1.width() >= 768;
            if (isPc_1 !== newValue || isPc_1 === null) {
                isPc_1 = newValue;
                if (isPc_1) {
                    // PC版
                    $twitterSp.children().appendTo($twitterPc);
                    $twitterSp.hide();
                    $twitterPc.show();
                }
                else {
                    // スマホ版
                    $twitterPc.children().appendTo($twitterSp);
                    $twitterPc.hide();
                    if (isTopPage) {
                        $twitterSp.show();
                        $twitterSp.find(".js_twitterTitle").show();
                    }
                    else {
                        $twitterSp.hide();
                    }
                }
            }
        };
        onResize();
        // $window.on("resize", onResize);
    }
}
if (document.readyState !== "loading") {
    windowLoaded();
}
else {
    document.addEventListener("DOMContentLoaded", windowLoaded);
}
